import { render } from "./EULAModal.vue?vue&type=template&id=574bec28&scoped=true"
import script from "./EULAModal.vue?vue&type=script&lang=js"
export * from "./EULAModal.vue?vue&type=script&lang=js"

import "./EULAModal.vue?vue&type=style&index=0&id=574bec28&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574bec28"]])

export default __exports__